<template>
    <div class="mask" @click="onMaskClick" v-if="show" :style="{'z-index': zIndex}">
        <div class="popover-content" @click.stop>
            <img v-if="closable" src="@/assets/img/popover/close.png" class="close-icon" @click.stop="close"/>
            <slot></slot>
        </div>
    </div>
</template>
<script>
    export default{
        props: {
            maskClosable: {
                type: Boolean,
                default: true
            },
            closable: {
                type: Boolean,
                default: true
            },
            zIndex: {
                type: Number,
                default: 100
            }
        },
        data(){
            return{
                show: false
            }
        },
        methods:{
            open(){
                this.show = true
            },
            close(){
                this.show = false
            },
            onMaskClick() {
                if (this.maskClosable) this.close()
            }

        }
    }
</script>
<style lang="scss" scoped>
    .notice-popover {
        &.mask{
            background: rgba(0, 0, 0, 0.85);
        }
        .popover-content{
            background: none;
            padding: 24px 0;
            .close-icon{
                width: 28px;
                height: 28px;
                right: 0;
            }
        }
    }
    .mask{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.75);
        z-index: 100;
    }
    .popover-content{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        width: 343px;
        padding: 24px;
        min-height: 180px;
        flex-direction: column;
        align-items: center;
        gap: 24px;
        background: url('@/assets/img/popover/bg.png') no-repeat center center;
        background-size: cover;
        border-radius: 24px;
        background-color: #17161A;
        box-sizing: border-box;
        z-index: 101;
        .close-icon{
            position: absolute;
            top: 18px;
            right: 18px;
            width: 24px;
            height: 24px;
        }
    }
</style>
